import { Button } from '@fluentui/react-components';
import styled from 'styled-components';

export const TicketInfoWrapper = styled.div`
  position: relative;
  justify-content: space-between;
  padding: 20px 32px 20px 32px;
  background: ${(props) => props.theme.mainBackgorund};
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
display: grid;
grid-template-columns: repeat(2, minmax(calc(50% - (16px / 2)), 1fr));
  div:nth-child(1), 
  div:nth-child(4) {
    grid-column: 1 / span 2;
  }
  gap: 16px;
`;

export const DoneButton = styled(Button)`
  margin-left: auto;
  width: 80px;
  gap: 4px;
`;

export const DoneButtonTextWrapper = styled.div`
  gap: 6px;
`;

export const DoneButtonText = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
`;